<template>
  <div v-show="show" class="root fixed w-screen h-full z-20">
    <div ref="loadingAnimation" class="loading-wrapper w-3/5 my-0 mx-auto" />
  </div>
</template>

<script>
import lottie from 'lottie-web';
import loading from '@/assets/animations/loading.json';
import loadingSanne from '@/assets/sanne/animations/loading.json';

// the plugin is mounted outside the app (no store), so the brand comes from
// the mode class App.vue keeps on <body>; the Sanne copy only swaps colours
const currentAnimation = () =>
  document.body.classList.contains('mode-sanne') ? loadingSanne : loading;

export default {
  data: () => ({
    animation: null,
    animationData: null,
    show: false,
  }),
  mounted() {
    this.loadAnimation();
  },
  beforeDestroy() {
    if (this.animation) {
      this.animation.destroy();
    }
  },
  methods: {
    loadAnimation() {
      const animationData = currentAnimation();
      if (this.animation && this.animationData === animationData) return;

      if (this.animation) this.animation.destroy();
      this.animationData = animationData;
      this.animation = lottie.loadAnimation({
        container: this.$refs.loadingAnimation,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    },
    setShow(data) {
      // the brand can change after the first open (store login / logout)
      if (data) this.loadAnimation();
      this.show = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  background-color: rgba(255, 255, 255, 0.75);
}

.loading-wrapper {
  height: 65%;
}
</style>
